import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import PredefinedPhrasesDiscourseSelection from './PredefinedPhrasesDiscourseSelection';
import { PredefineDiscoursePhrase } from '../PredefinedPhrasesDiscourseSetup';
import { Size } from '../../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	onSelect: (item: PredefineDiscoursePhrase) => void;
}

const PredefinedPhrasesDiscourseSelectionModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.predefinedPhraseSelection.modalTitle'
			contentStyle={{ padding: 0 }}
			contentScroll={false}
			size={Size.FULLSCREEN}>
			<PredefinedPhrasesDiscourseSelection onSelect={props.onSelect} />
		</BaseModal>
	);
};

export default PredefinedPhrasesDiscourseSelectionModal;
